var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuggestions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 79"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3348 21.0076C17.3348 19.8306 17.9033 18.7454 18.6759 17.8574C20.2567 16.0408 21.2138 13.6672 21.2138 11.07C21.2138 5.35681 16.5823 0.725342 10.8691 0.725342C5.15589 0.725342 0.524414 5.35681 0.524414 11.07C0.524414 13.6674 1.48166 16.0412 3.06261 17.8578C3.83537 18.7458 4.40394 19.8311 4.40394 21.0082V24.001C4.40394 26.1435 6.14074 27.8803 8.28319 27.8803H13.4555C15.598 27.8803 17.3348 26.1435 17.3348 24.001V21.0076Z",
    fill: "#EFF4F1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 75",
    x: 3.11035,
    y: 24.2317,
    width: 15.517,
    height: 2.58617,
    rx: 1.29309,
    fill: "#8BA293"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 76",
    x: 4.4043,
    y: 26.2175,
    width: 12.9309,
    height: 2.58617,
    rx: 1.29309,
    fill: "#8BA293"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 77",
    x: 5.69727,
    y: 28.6885,
    width: 10.3447,
    height: 2.58617,
    rx: 1.29309,
    fill: "#8BA293"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M6.99023 13.0098L9.57641 15.596L15.3953 9.7771",
    stroke: "#8BA293",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 23",
    d: "M28.4023 10.991H25.2158",
    stroke: "#FFA692",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 24",
    d: "M26.8086 3.81226L24.1063 5.50086",
    stroke: "#FFA692",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 26",
    d: "M26.8086 18.1699L24.1063 16.4813",
    stroke: "#FFA692",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuggestions);
export default __webpack_public_path__ + "static/media/suggestions.39a1bd2020cafa257ab59513de6eb2ee.svg";
export { ForwardRef as ReactComponent };